(() => {
  if (!window.Zeta || !window.Zeta.config.enabled || !window.Zeta.config.suggestEnabled) {
    return;
  }

  const Drawer = window.customElements.get('predictive-search-drawer');
  if (!Drawer) {
    return;
  }

  const SEARCH_HISTORY_KEY = 'zeta_search_history';
  const SEARCH_HISTORY_MAX = 10;
  const SUGGEST_PRODUCT_LIMIT = 6;

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (char) => {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function keywordLink(keyword, className) {
    const href = escapeHtml(window.Zeta.buildResultsUrl(keyword));
    return `<a class="${className}" href="${href}">${escapeHtml(keyword)}</a>`;
  }

  function productCard(item) {
    const href = escapeHtml(item.url);
    const img = escapeHtml(item.imageUrl);
    const priceClass = item.onSale ? 'zeta-suggest__price zeta-suggest__price--sale' : 'zeta-suggest__price';
    const imageSource = img ? ` src="${img}"` : '';
    const media = `<img${imageSource} alt="" loading="lazy" width="200" height="266" data-zeta-suggest-image
      data-zeta-item-id="${escapeHtml(item.id)}" data-zeta-sku="${escapeHtml(item.sku)}"
      data-zeta-color-code="${escapeHtml(item.colorCode)}" data-zeta-color-name="${escapeHtml(item.colorName)}">`;
    return `<a class="zeta-suggest__product" href="${href}">
      <span class="zeta-suggest__product-media">${media}</span>
      <span class="zeta-suggest__product-name">${escapeHtml(item.title)}</span>
      <span class="${priceClass}">${escapeHtml(window.Zeta.formatMoney(item.price))}</span>
    </a>`;
  }

  async function fetchSuggestItems(term) {
    try {
      return await window.Zeta.fetchItems({ q: term, l: SUGGEST_PRODUCT_LIMIT, stock: 0 });
    } catch (error) {
      console.error('[ZETA] suggest items', error);
      return { items: [] };
    }
  }

  async function buildSuggestResult(term) {
    try {
      const [suggest, itemsResult] = await Promise.all([
        window.Zeta.fetchSuggest(term),
        fetchSuggestItems(term),
      ]);

      const keywordSections = [];
      if (suggest.suggestions.length > 0) {
        const links = suggest.suggestions.map((w) => `<li>${keywordLink(w, 'zeta-suggest__link')}</li>`).join('');
        keywordSections.push(
          `<p class="zeta-suggest__title">もしかして</p><ul class="zeta-suggest__list">${links}</ul>`,
        );
      }
      if (suggest.popularWords.length > 0) {
        const chips = suggest.popularWords.map((w) => keywordLink(w, 'zeta-suggest__keyword')).join('');
        keywordSections.push(
          `<p class="zeta-suggest__title">人気のキーワード</p><div class="zeta-suggest__chips">${chips}</div>`,
        );
      }

      const products = itemsResult.items || [];
      let productsHtml = '';
      if (products.length > 0) {
        const cards = products.map(productCard).join('');
        productsHtml = `<p class="zeta-suggest__title">${escapeHtml(term)}</p>
          <div class="zeta-suggest__products">${cards}</div>`;
      }

      const hasResults = keywordSections.length > 0 || products.length > 0;
      const html = `<div class="zeta-suggest">${keywordSections.join('')}${productsHtml}</div>`;
      return { hasResults, html };
    } catch (error) {
      console.error('[ZETA] suggest', error);
      return { hasResults: false, html: '' };
    }
  }

  Drawer.prototype._doPredictiveSearch = function doPredictiveSearch(term) {
    return buildSuggestResult(term);
  };
  Drawer.prototype._doLiquidSearch = function doLiquidSearch(term) {
    return buildSuggestResult(term);
  };

  function readSearchHistory() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(SEARCH_HISTORY_KEY) || '[]');
      return Array.isArray(stored) ? stored.slice(0, SEARCH_HISTORY_MAX) : [];
    } catch (error) {
      console.error('[ZETA] search history', error);
      return [];
    }
  }

  function buildKeywordLink(keyword, className) {
    const link = document.createElement('a');
    link.className = className;
    link.href = window.Zeta.buildResultsUrl(keyword);
    link.textContent = keyword;
    return link;
  }

  function initializeInitialPanel() {
    const drawer = document.querySelector('#search-drawer');
    const contentWrapper = drawer?.querySelector('.predictive-search__content-wrapper');
    const menuList = contentWrapper?.querySelector('.predictive-search__menu-list');
    const input = drawer?.querySelector('[name="q"]');
    if (!drawer || !contentWrapper || !input) {
      return;
    }

    const panel = document.createElement('div');
    panel.className = 'zeta-suggest__initial';

    const history = readSearchHistory();
    if (history.length > 0) {
      const historySection = document.createElement('div');
      historySection.className = 'zeta-suggest__initial-section';
      const historyTitle = document.createElement('p');
      historyTitle.className = 'zeta-suggest__title';
      historyTitle.textContent = '検索履歴';
      const historyList = document.createElement('ul');
      historyList.className = 'zeta-suggest__list';
      history.forEach((keyword) => {
        const listItem = document.createElement('li');
        listItem.appendChild(buildKeywordLink(keyword, 'zeta-suggest__link'));
        historyList.appendChild(listItem);
      });
      historySection.appendChild(historyTitle);
      historySection.appendChild(historyList);
      panel.appendChild(historySection);
    }

    const popularSection = document.createElement('div');
    popularSection.className = 'zeta-suggest__initial-section';
    popularSection.hidden = true;
    panel.appendChild(popularSection);
    contentWrapper.insertBefore(panel, menuList || null);

    let popularWordsRequested = false;
    input.addEventListener('focus', async () => {
      if (popularWordsRequested) {
        return;
      }
      popularWordsRequested = true;
      try {
        const suggest = await window.Zeta.fetchSuggest('');
        if (suggest.popularWords.length === 0) {
          return;
        }
        const title = document.createElement('p');
        title.className = 'zeta-suggest__title';
        title.textContent = '人気のキーワード';
        const chips = document.createElement('div');
        chips.className = 'zeta-suggest__chips';
        suggest.popularWords.forEach((keyword) => {
          chips.appendChild(buildKeywordLink(keyword, 'zeta-suggest__keyword'));
        });
        popularSection.appendChild(title);
        popularSection.appendChild(chips);
        popularSection.hidden = false;
      } catch (error) {
        console.error('[ZETA] initial popular words', error);
      }
    });

    const togglePanel = () => {
      panel.hidden = input.value.trim().length > 0;
    };
    input.addEventListener('input', togglePanel);
    togglePanel();
  }

  // ドロワーへ追加されたサジェスト商品画像だけをフォールバック処理へ渡す。
  function initializeImageFallbackObserver() {
    const drawer = document.querySelector('#search-drawer');
    if (!drawer) {
      return;
    }

    const imageSelector = '[data-zeta-suggest-image]';
    const pendingImageSelector = `${imageSelector}:not([data-zeta-image-repair])`;
    const observer = new MutationObserver((mutations) => {
      const hasAddedImage = mutations.some((mutation) => {
        return Array.from(mutation.addedNodes).some((node) => {
          return (
            node instanceof Element &&
            (node.matches(pendingImageSelector) || node.querySelector(pendingImageSelector))
          );
        });
      });
      if (!hasAddedImage) {
        return;
      }
      window.Zeta.repairProductImages(drawer, { imageSelector });
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  initializeInitialPanel();
  initializeImageFallbackObserver();
})();
